import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { TechChecklist } from "@/components/TechChecklist";
import { PartsPicker } from "@/components/PartsPicker";
import { CheckCircle2 } from "lucide-react";

export const ConcludeOSDialog = ({ os, open, onOpenChange, technicians, onConfirm, saving }) => {
  const { user } = useAuth();
  const [techIds, setTechIds] = useState([]);
  const [items, setItems] = useState([]);
  const [downtime, setDowntime] = useState(0);
  const [executed, setExecuted] = useState("");
  const [parts, setParts] = useState([]);

  useEffect(() => {
    if (!open) { return; }
    const ids = os.technician_ids?.length ? [...os.technician_ids] : (os.technician_id ? [os.technician_id] : []);
    if (user?.role === "tecnico" && !ids.includes(user.id)) ids.unshift(user.id);
    setTechIds(ids);
    setItems([]);
    setDowntime(os.downtime_minutes || 0);
    setExecuted(os.executed_actions || "");
    api.get("/parts").then((r) => setParts(r.data)).catch(() => {});
  }, [open, os, user]);

  const submit = () => onConfirm({
    status: "Concluída",
    technician_ids: techIds,
    parts_items: items,
    downtime_minutes: Number(downtime) || 0,
    executed_actions: executed,
  });

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-xl max-h-[90vh] overflow-y-auto" data-testid="conclude-os-dialog">
        <DialogHeader>
          <DialogTitle>Concluir OS #{os.number}</DialogTitle>
          <DialogDescription>Confirme a equipe que participou, as peças usadas e o tempo parado. As peças serão baixadas do estoque.</DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <div>
            <Label>Técnicos que participaram</Label>
            <TechChecklist technicians={technicians} value={techIds} onChange={setTechIds} testPrefix="conclude-tech" />
          </div>
          <div>
            <Label>Peças do estoque utilizadas</Label>
            <div className="mt-1.5"><PartsPicker parts={parts} value={items} onChange={setItems} /></div>
          </div>
          <div className="grid sm:grid-cols-3 gap-3">
            <div>
              <Label>Tempo parado (min)</Label>
              <Input type="number" min="0" value={downtime} onChange={(e) => setDowntime(e.target.value)} className="rounded-sm mt-1.5" data-testid="conclude-downtime" />
            </div>
            <div className="sm:col-span-2">
              <Label>Ações executadas</Label>
              <Textarea value={executed} onChange={(e) => setExecuted(e.target.value)} rows={2} className="rounded-sm mt-1.5" data-testid="conclude-executed" />
            </div>
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} className="rounded-sm">Cancelar</Button>
          <Button onClick={submit} disabled={saving} className="rounded-sm bg-green-600 hover:bg-green-700 text-white gap-2" data-testid="conclude-confirm">
            <CheckCircle2 className="w-4 h-4" /> {saving ? "Concluindo..." : "Concluir OS"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
